function About() {
    return (
      <div className="section">
        <h4>О НАС:</h4>
        <div class="alert alert-success d-flex align-items-center px-3" role="alert">
              <div className="p-4">
                <p>
                Все пути одинаковы - они никуда не ведут. Могу признаться: в своей жизни я прошёл немало путей, но так никуда и не пришёл. Теперь вопрос благодетеля обрёл для меня смысл. Есть ли у этого пути сердце? Если есть - путь хорош; если нет - он бесполезен. Все пути никуда не ведут, но у одного есть сердце, а у другого - нет. Один путь доставляет радость, и пока ты идёшь по нему - ты неотделим от него; а другой путь заставляет тебя проклинать всю свою жизнь. Один путь наделяет тебя силой, другой - лишает её.
                </p>
                <p>
                Чтобы извлечь из жизни максимум, человек должен уметь изменяться. К сожалению, человек изменяется с большим трудом, и изменения эти происходят очень медленно. Многие тратят на это годы. Самым трудным является по-настоящему захотеть измениться.
                </p>
              </div>
            </div>  
      </div>
    );
  }
  
  export default About;

            